import CustomTooltip from "@/components/CustomTooltip";
import { Info } from "@phosphor-icons/react";
import Image from "next/image";
import clockIcon from "@/assets/icons/clock-icon.webp";

export default function MedianTimeUnicorn({
  unicornStats,
  selectedCountryName,
  selectedRegionName,
}) {
  // From your other components, your API uses total_unicorn
  const totalUnicorns = unicornStats?.total_unicorn || 0;
  const hasUnicorns = totalUnicorns > 0;

  const median = unicornStats?.median_time_to_unicorn ?? null;
  const hasMedian =
    median !== null && Number.isFinite(Number(median)) && Number(median) >= 0;

  const formatYears = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num) || num < 0) return null;
    return num.toFixed(1);
  };

  const formattedYears = hasMedian ? formatYears(median) : null;

  const showNotApplicable = !hasUnicorns;
  const showNoData = hasUnicorns && formattedYears === null;

  return (
    <>
      <div className='flex items-center justify-between gap-1.5'>
        <p className='text-base font-medium sm:text-sm'>Avg. Time to Unicorn</p>
        <CustomTooltip
          trigger={
            <span className='-mt-2 -mr-2 text-white/40'>
              <Info className='size-5' />
            </span>
          }
          content="Simple average of the time between each company's founding date and its unicorn event date (first $1B+ valuation), across the matching companies. Based on current HQ."
        />
      </div>

      <div className='flex items-center gap-3 mt-2.5'>
        <div className='relative size-9'>
          <Image src={clockIcon.src} layout='fill' alt='Total Funding' />
        </div>

        <div className='flex flex-col'>
          {showNotApplicable ? (
            <>
              <span className='text-xl font-semibold tracking-tight'>
                Not Applicable
              </span>
              <span className='mt-1 text-xs opacity-40'>
                No unicorns in this selection.
              </span>
            </>
          ) : showNoData ? (
            <>
              <span className='text-3xl font-bold tracking-tight'>N/A</span>
              <span className='text-xs opacity-40'>
                Time-to-unicorn data not available.
              </span>
            </>
          ) : (
            <span className='text-3xl font-bold tracking-tight'>
              {formattedYears} years
            </span>
          )}
        </div>
      </div>
    </>
  );
}
